var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.8,
    r: 12,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_365_1749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.94795 17.7375C7.70278 17.7517 7.46166 17.6702 7.27544 17.5102C6.90819 17.1407 6.90819 16.544 7.27544 16.1746L15.3172 8.13279C15.6992 7.77536 16.2986 7.79523 16.656 8.17721C16.9792 8.52264 16.9981 9.05356 16.7001 9.42101L8.61098 17.5102C8.42716 17.6679 8.18991 17.7493 7.94795 17.7375Z",
    fill: "#5E6366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9803 17.7375C15.7318 17.7365 15.4937 17.6378 15.3172 17.4628L7.27543 9.421C6.93518 9.02367 6.98144 8.42571 7.37877 8.08543C7.7334 7.78174 8.2564 7.78174 8.61099 8.08543L16.7001 16.1272C17.082 16.4848 17.1018 17.0842 16.7443 17.4661C16.73 17.4813 16.7153 17.496 16.7001 17.5102C16.5021 17.6824 16.2414 17.7647 15.9803 17.7375Z",
    fill: "#5E6366"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_365_1749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(7 7.80005)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseApp);
export default __webpack_public_path__ + "static/media/ICON_CLOSE_APP.1694969dc3ef8fa723dd9056e520a354.svg";
export { ForwardRef as ReactComponent };